import React, { useCallback, useState } from 'react';

import { Container, StyledCheckbox, Icon } from './styles';

interface CheckboxProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange'
> {
  onChange(value: boolean): void;
  checked: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  checked,
  ...shared
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [isFocus, setIsFocused] = useState(false);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handleContainerClick = useCallback(() => {
    // Forçar o foco no input quando o container é clicado
    inputRef.current?.focus();
  }, []);

  return (
    <Container $isFocused={isFocus} onClick={handleContainerClick}>
      <input
        type="checkbox"
        checked={checked}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        onChange={e => onChange(e.target.checked)}
        ref={inputRef}
        {...shared}
      />
      <StyledCheckbox $check={checked}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </Container>
  );
};

export default Checkbox;
